'use strict';
cashReconciliationController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$uibModal',
	'reportHelper',
	'bankService',
	'outstandingCheckService',
	'bankReconLogService',
	'BUSY_MESSAGE',
	'authService',
	'USER_CLAIMS',
	'ROLE_CLAIMS',
];
angular.module('schoolLinqApp').controller('cashReconciliationController', cashReconciliationController);

function cashReconciliationController(
	$scope,
	$rootScope,
	$q,
	$uibModal,
	reportHelper,
	bankService,
	outstandingCheckService,
	bankReconLogService,
	BUSY_MESSAGE,
	authService,
	USER_CLAIMS,
	ROLE_CLAIMS
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.busyPromise = $q.all([$scope.vm.loadBanks($scope.vm)]);

	$scope.hasImportAmountError = function (check) {
		return check.SavedAmountForRecon && check.SavedAmountForRecon !== check.PostAmount;
	};

	function getViewModel(moduleName) {
		var fieldClaims = authService.authentication.fieldClaims;
		var docMgmtPermission = null; // authService.hasPageClaim(payableClaims, 'CashReconciliationDocMgmt', USER_CLAIMS.fund, 'cash');
		var addChecksAndDepositsPermission = false;
		var addChecksAndDepositsPermissionSA = authService.hasWriteAccess('lsb', 'cash', 'BankReconciliationAddItems');

		var model = {
			module: moduleName,
			checks: [],
			deposits: [],
			banks: [],
			StatementBalance: 0,
			statement: {
				checks: [],
				deposits: [],
			},
			filter: {
				selectedBank: null,
				selectedBankBookBalance: 0,
				endingDate: moment().toDate(),
				retrieve: false,
				check: {
					propertyName: 'CheckOrDepositNo',
					reverse: false,
				},
				deposit: {
					propertyName: 'CheckOrDepositNo',
					reverse: false,
				},
			},
			busyMessage: BUSY_MESSAGE.Loading,
			errors: null,
			docMgmt: {
				permissionLevel: docMgmtPermission,
				hasConfidentialAccess: !!_.findWhere(fieldClaims, {
					ClaimValue: ROLE_CLAIMS.FundManagementManageRequisitionsDocMgmtConfidential,
				}),
				hasDeleteAccess: !!_.findWhere(fieldClaims, {
					ClaimValue: ROLE_CLAIMS.FundManagementManageRequisitionsDocMgmtDelete,
				}),
			},
			addPermissions: addChecksAndDepositsPermission,
			addPermissionsSA: addChecksAndDepositsPermissionSA,
		};

		function sortChecksBy(model, propertyName) {
			model.filter.check.reverse = model.filter.check.propertyName === propertyName ? !model.filter.check.reverse : false;
			model.filter.check.propertyName = propertyName;
		}

		function sortDepositsBy(model, propertyName) {
			model.filter.deposit.reverse = model.filter.deposit.propertyName === propertyName ? !model.filter.deposit.reverse : false;
			model.filter.deposit.propertyName = propertyName;
		}

		function loadBanks(model) {
			return bankService.getBanks(false, true).then(_.partial(finishLoadingBanks, model));

			function finishLoadingBanks(model, response) {
				model.banks = response.data.banks;
				model.filter.selectedBank = model.banks[0];
				return angular.noop;
			}
		}

		function retrieveStatement(model) {
			if (model.filter.selectedBank.Id && model.filter.endingDate) {
				model.busyMessage = BUSY_MESSAGE.Loading;
				$scope.busyPromise = $q
					.all([loadBankBalance(model)])
					.then(function () {
						return loadChecksAndDeposits(model);
					})
					.then(function () {
						model.filter.retrieve = true;
					});
			}

			function loadBankBalance(model) {
				return bankService
					.getBankBookBalance(model.filter.selectedBank.Id, model.filter.endingDate)
					.then(_.partial(finishLoadingBookBalance, model));

				function finishLoadingBookBalance(model, response) {
					model.filter.selectedBankBookBalance = response.data.bookbalance || 0;
					return angular.noop;
				}
			}

			function loadChecksAndDeposits(model) {
				return outstandingCheckService
					.getItemsForBankRecon(model.filter.selectedBank.Id, model.filter.endingDate)
					.then(_.partial(finishLoadingChecksAndDeposits, model));
			}
		}

		function onImportResult(model, response) {
			const modifiedResponse = { data: response };
			finishLoadingChecksAndDeposits(model, modifiedResponse);
		}

		function finishLoadingChecksAndDeposits(model, response) {
			// if any of the items have a void date then we need to ensure they are not marked as SavedForBankRecon in table OutstandingChecks
			var voids = _.filter(response.data.items, function (item) {
				return item.VoidDT;
			});
			angular.forEach(voids, function (item) {
				if (item.Selected) {
					model.autoSave(item);
				}
			});

			model.checks = _.filter(response.data.items, function (item) {
				return (
					item.RecordType === 'C' || item.RecordType === 'E' || item.RecordType === 'A' || (item.RecordType === 'B' && item.PostAmount < 0)
				);
			});
			model.deposits = _.filter(response.data.items, function (item) {
				return item.RecordType === 'D' || (item.RecordType === 'B' && item.PostAmount > 0);
			});

			// fix up any negative BankEntries
			_.each(model.checks, function (item) {
				if (item.RecordType === 'B' && item.PostAmount < 0) item.PostAmount *= -1;
			});

			return angular.noop;
		}

		function allCheckSelected(model) {
			var numberChecked = _.filter(model.checks, function (check) {
				return check.Selected === true;
			}).length;

			return (
				numberChecked ===
				_.filter(model.checks, function (check) {
					return !check.VoidDT;
				}).length
			);
		}

		function allDepositsSelected(model) {
			var numberDeposit = _.filter(model.deposits, function (deposit) {
				return deposit.Selected === true;
			}).length;

			return (
				numberDeposit ===
				_.filter(model.deposits, function (deposit) {
					return !deposit.VoidDT;
				}).length
			);
		}

		function selectAllChecks(model) {
			var select = true;
			if (model.allCheckSelected()) {
				select = false;
			}

			angular.forEach(model.checks, function (check) {
				if (!check.VoidDT && check.Selected !== select) {
					model.autoSave(check);
				}
			});
		}

		function selectAllDeposits(model) {
			var select = true;
			if (model.allDepositsSelected()) {
				select = false;
			}

			angular.forEach(model.deposits, function (deposit) {
				if (!deposit.VoidDT && deposit.Selected !== select) {
					model.autoSave(deposit);
				}
			});
		}

		function preprocess(model) {
			var adjBalance = emsRound(model.calAdjustedBalance());
			var bookBalance = emsRound(model.filter.selectedBankBookBalance);
			if (adjBalance !== bookBalance) {
				$uibModal
					.open({
						template: require('@ajs/templates/fund/cash/reconciliation-confirmunbalanced-modal.html'),
						backdrop: 'static',
						keyboard: false,
						scope: $scope,
						controller: [
							'$scope',
							'$uibModalInstance',
							function ($scope, modalInstance) {
								angular.extend($scope, {
									cancel: function () {
										modalInstance.close();
									},
									continueProcessing: function () {
										modalInstance.close(true);
									},
								});
							},
						],
					})
					.result.then(function (proceed) {
						if (proceed) {
							doProcessing(model);
						}
					});
			} else {
				doProcessing(model);
			}
		}

		function doProcessing(model) {
			var selectedChecks = _.filter(model.checks, function (item) {
				return item.Selected;
			});
			var selectedDeposits = _.filter(model.deposits, function (item) {
				return item.Selected;
			});
			var items = selectedChecks.concat(selectedDeposits);
			angular.forEach(items, function (item) {
				item.ClearDT = moment(model.filter.endingDate, 'YYYY-MM-DD').format().substring(0, 10);
			});

			model.busyMessage = BUSY_MESSAGE.Saving;
			$scope.busyPromise = outstandingCheckService.reconcile(items).then(_.partial(finishSaving, model));

			function finishSaving(model, response) {
				if (response.data.isValid) {
					model.retrieveStatement();
					model.openReport();
				}
				return angular.noop;
			}
		}

		function openReport(model) {
			var report = {
				BankId: model.filter.selectedBank.Id,
				BankName: model.filter.selectedBank.DisplayName,
				BankReconEndDT: model.filter.endingDate,
				StatementBalance: model.StatementBalance || 0,
				OutstandingChecksTotal: model.calOutstandingChecksTotal() || 0,
				OutstandingDepositsTotal: model.calOutstandingDepositsTotal() || 0,
				AdjustedBalance: model.calAdjustedBalance() || 0,
				BookBalance: model.filter.selectedBankBookBalance || 0,
				BalanceDifference: model.calDifference() || 0,
			};

			// save bank recon summary report to log table
			bankReconLogService.add(report);

			reportHelper.postReportToModal($scope, '/api/fundreports/bankreconciliationsummary', report, 'BankReconciliationSummary.pdf');
		}

		function autoSave(model, item) {
			item.Saving = true;
			item.error = false;
			var updateItem = {
				Id: item.Id,
				SavedForBankRecon: false,
				SavedAmountForRecon: null,
				ClearAmount: null,
				ClearDT: null,
			};

			if (!item.Selected) {
				updateItem.SavedForBankRecon = true;
				updateItem.SavedAmountForRecon = item.PostAmount;
			}

			outstandingCheckService.updateCheck(updateItem).then(_.partial(finishSaving, model));

			function finishSaving(modal, response) {
				if (response.data.isValid) {
					item.Selected = !item.Selected;
				} else {
					item.error = true;
				}
				item.Saving = false;
			}
		}

		function calDepositsTotal(model) {
			if (!model.deposits) return 0;
			return _.reduce(
				model.deposits,
				function (num, deposit) {
					if (deposit.Selected) {
						return num + (Number(deposit.PostAmount) || 0);
					}
					return num;
				},
				0
			);
		}

		function calOutstandingDepositsTotal(model) {
			if (!model.deposits) return 0;
			return _.reduce(
				model.deposits,
				function (num, deposit) {
					if (!deposit.Selected) {
						return num + (Number(deposit.PostAmount) || 0);
					}
					return num;
				},
				0
			);
		}

		function calChecksTotal(model) {
			if (!model.checks) return 0;
			return _.reduce(
				model.checks,
				function (num, check) {
					if (check.Selected) {
						return num + (Number(check.PostAmount) || 0);
					}
					return num;
				},
				0
			);
		}

		function calOutstandingChecksTotal(model) {
			if (!model.checks) return 0;
			return _.reduce(
				model.checks,
				function (num, check) {
					if (!check.Selected) {
						return num + (Number(check.PostAmount) || 0);
					}
					return num;
				},
				0
			);
		}

		function calAdjustedBalance(model) {
			return (model.StatementBalance || 0) - model.calOutstandingChecksTotal() + model.calOutstandingDepositsTotal();
		}

		function calDifference(model) {
			return model.calAdjustedBalance() - model.filter.selectedBankBookBalance;
		}

		function addCheck(model) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/cash/reconciliation-addcheck-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						'outstandingCheckService',
						'bankService',
						function ($scope, modalInstance, outstandingCheckService, bankService) {
							$scope.adjustment = {
								BankId: model.filter.selectedBank.Id,
								RecordType: 'A',
								ManualEntry: true,
							};

							angular.extend($scope, {
								cancel: function () {
									modalInstance.close();
								},
								saveAdjustment: function () {
									if (!$scope.checkForm.$valid) return false;
									if (!$scope.adjustment.PostDT || $scope.adjustment.PostDT > $scope.vm.filter.endingDate) {
										$scope.errors = 'Adjustment Date must be before or on the selected Statement Ending Date.';
									} else {
										$scope.errors = '';
										$scope.adjustment.SavedAmountForRecon = $scope.adjustment.PostAmount;
										$scope.savingPromise = outstandingCheckService.addCheck($scope.adjustment).then(finishSavingAdjustment);
									}

									function finishSavingAdjustment(response) {
										if (response.data.isValid) {
											modalInstance.close('reload');
										} else {
											$scope.errors = response.data.errors;
										}
									}
								},
							});
						},
					],
				})
				.result.then(function (reload) {
					if (reload) {
						model.retrieveStatement();
					}
				});
		}

		function addDeposit(model) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/cash/reconciliation-adddeposit-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						'outstandingCheckService',
						function ($scope, modalInstance, outstandingCheckService) {
							$scope.adjustment = {
								BankId: model.filter.selectedBank.Id,
								RecordType: 'D',
								CheckOrDepositNo: model.filter.selectedBank.NextDepositNumber,
								ManualEntry: true,
							};

							angular.extend($scope, {
								cancel: function () {
									modalInstance.close();
								},
								saveAdjustment: function () {
									if (!$scope.depositForm.$valid) return false;
									if (!$scope.adjustment.PostDT || $scope.adjustment.PostDT > $scope.vm.filter.endingDate) {
										$scope.errors = 'Deposit Date must be before or on the selected Statement Ending Date.';
									} else {
										$scope.errors = '';
										$scope.adjustment.SavedAmountForRecon = $scope.adjustment.PostAmount;
										$scope.savingPromise = outstandingCheckService
											.addCheck($scope.adjustment)
											.then(finishSavingAdjustment)
											.then(refreshBanks);
									}

									function finishSavingAdjustment(response) {
										if (response.data.isValid) {
											modalInstance.close('reload');
										} else {
											$scope.errors = response.data.errors;
										}
									}
									function refreshBanks(response) {
										return bankService.getBanks(false, true).then(_.partial(finishLoadingBanks, $scope.vm));

										function finishLoadingBanks(model, response) {
											model.banks = response.data.banks;
											model.filter.selectedBank = _.findWhere(model.banks, {
												Id: model.filter.selectedBank.Id,
											});
										}
									}
								},
							});
						},
					],
				})
				.result.then(function (reload) {
					if (reload) {
						model.retrieveStatement();
					}
				});
		}

		function deleteItem(model, id) {
			model.busyMessage = BUSY_MESSAGE.Deleting;
			$scope.busyPromise = outstandingCheckService.deleteCheck(id).then(_.partial(finishDeleting, model));

			function finishDeleting(model, response) {
				if (response.data.isValid) {
					model.retrieveStatement();
				}
			}
		}

		return angular.extend(model, {
			sortChecksBy: _.partial(sortChecksBy, model),
			sortDepositsBy: _.partial(sortDepositsBy, model),
			loadBanks: _.partial(loadBanks, model),
			retrieveStatement: _.partial(retrieveStatement, model),
			allCheckSelected: _.partial(allCheckSelected, model),
			allDepositsSelected: _.partial(allDepositsSelected, model),
			selectAllChecks: _.partial(selectAllChecks, model),
			selectAllDeposits: _.partial(selectAllDeposits, model),
			preprocess: _.partial(preprocess, model),
			process: _.partial(doProcessing, model),
			openReport: _.partial(openReport, model),
			autoSave: _.partial(autoSave, model),
			calDepositsTotal: _.partial(calDepositsTotal, model),
			calOutstandingDepositsTotal: _.partial(calOutstandingDepositsTotal, model),
			calChecksTotal: _.partial(calChecksTotal, model),
			calOutstandingChecksTotal: _.partial(calOutstandingChecksTotal, model),
			calAdjustedBalance: _.partial(calAdjustedBalance, model),
			calDifference: _.partial(calDifference, model),
			addCheck: _.partial(addCheck, model),
			addDeposit: _.partial(addDeposit, model),
			deleteItem: _.partial(deleteItem, model),
			onImportResult: _.partial(onImportResult, model),
		});
	}
}
